import { Text, TextProps } from '@fly/core';
import { format } from 'timeago.js';

export function FlyTimeago({
  date,
  language,
  short = false,
  hideTitle = false,

  ...props
}: {
  date: Date | string;
  language: string;
  short?: boolean;
  hideTitle?: boolean;
} & Omit<TextProps, 'children'>) {
  let finalLanguage = language;

  if (language === 'en' && short) {
    finalLanguage = 'en_short';
  }

  if (!date) {
    return <Text {...props}>N/A</Text>;
  }

  return (
    <Text
      {...props}
      title={hideTitle ? undefined : new Date(date).toUTCString()}
    >
      {format(date, finalLanguage)}
    </Text>
  );
}
